export const GET_APPLICATION_SUBSTATUS_DEF = "GET_APPLICATION_SUBSTATUS_DEF"
export const GET_APPLICATION_SUBSTATUS_DEF_SUCCESS = "GET_APPLICATION_SUBSTATUS_DEF_SUCCESS"
export const GET_APPLICATION_SUBSTATUS_DEF_FAIL = "GET_APPLICATION_SUBSTATUS_DEF_FAIL"

export const API_ERROR = "API_ERROR"
